// extracted by mini-css-extract-plugin
module.exports = {"portal":"style_portal__Ugs3e","header":"style_header__QOzDn","content":"style_content__DLbCv","actions":"style_actions__pSnR3","button":"style_button__wicOM"};